// extracted by mini-css-extract-plugin
module.exports = {"container":"wc","hide":"wd","content":"we","close":"wf","closeIcon":"wh","svgStyles":"wi"};